<template>
  <BaseBlock title="Consultation des archives">
    <v-row justify="center">
      <v-col>
        <v-data-table
          :headers="headers"
          :items="candidaturesArchives"
          :server-items-length="totalItems"
          :options.sync="options"
          :loading="searchLoading"
          @update:options="getCandidaturesArchives"
          :footer-props="{
            'items-per-page-options': [5, 10, 25, 50, -1],
          }"
          multi-sort
        >
          <template #top>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header class="d-flex justify-center">
                  <div class="text-center flex-grow-1">
                    Filtrer les résultats
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-form ref="filtersFormRef" v-model="filtersFormValid">
                    <v-row class="d-flex justify-center align-center">
                      <v-col cols="12" class="pt-0 pb-0">
                        <v-text-field
                          v-model="filters.etudiantEmailPattern"
                          dense
                          placeholder="Email"
                          type="email"
                          :rules="[
                            (v) =>
                              !v ||
                              (v && v.length >= 5) ||
                              'Minimum 5 caractères',
                            (v) =>
                              !v ||
                              (v && /.+@.+\..+/.test(v)) ||
                              'Email invalide',
                          ]"
                          :loading="searchLoading"
                          clearable
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex justify-space-between align-center">
                      <v-col cols="2" class="pt-0 pb-3">
                        <v-subheader class="pa-0">
                          Période de dépôt
                        </v-subheader>
                      </v-col>
                      <v-col cols="5">
                        <v-menu
                          v-model="dateDepotDebutMenuShow"
                          :close-on-content-click="false"
                          offset-y
                          min-width="auto"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              :value="dateDepotDebutFormatted"
                              label="Du ..."
                              readonly
                              dense
                              v-bind="attrs"
                              v-on="on"
                              clearable
                              :loading="searchLoading"
                              @click:clear.stop="filters.dateDepotDebut = null"
                              :rules="dateDepotDebutRules"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="filters.dateDepotDebut"
                            :show-current="true"
                            color="primary"
                            hide-header
                            @input="dateDepotDebutMenuShow = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col cols="5">
                        <v-menu
                          v-model="dateDepotFinMenuShow"
                          :close-on-content-click="false"
                          offset-y
                          min-width="auto"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              :value="dateDepotFinFormatted"
                              label="Au ..."
                              readonly
                              dense
                              v-bind="attrs"
                              v-on="on"
                              clearable
                              :loading="searchLoading"
                              @click:clear.stop="filters.dateDepotFin = null"
                              :rules="dateDepotFinRules"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="filters.dateDepotFin"
                            :show-current="true"
                            color="primary"
                            hide-header
                            @input="dateDepotFinMenuShow = false"
                          />
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template v-slot:[`item.dateDepot`]="{ item }">
            <span>{{ formatDate(item.dateDepot) }}</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ma-2"
                  text
                  icon
                  color="primary"
                  @click="ouvrirArchive(item.id)"
                  v-bind="attrs"
                  v-on="on"
                  :loading="loadingArchiveId === item.id"
                >
                  <template v-slot:loader>
                    <v-progress-circular
                      indeterminate
                      size="20"
                      width="2"
                      color="primary"
                    />
                  </template>
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Ouvrir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col>
        <v-dialog v-model="archiveDialogShow" persistent>
          <v-card v-if="currentCandidatureArchive">
            <v-card-title class="text-h5 justify-center text-success">
              Détail de l'archive
            </v-card-title>
            <v-card-text>
              <v-form>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      label="Nom"
                      :value="currentCandidatureArchive.etudiantNom"
                      readonly
                      outlined
                      dense
                    />
                  </v-col>

                  <v-col cols="4">
                    <v-text-field
                      label="Prénom"
                      :value="currentCandidatureArchive.etudiantPrenom"
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Email"
                      :value="currentCandidatureArchive.etudiantEmail"
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      label="Libellé Formation"
                      :value="currentCandidatureArchive.formationLibelle"
                      readonly
                      outlined
                      dense
                    />
                  </v-col>

                  <v-col cols="4">
                    <v-text-field
                      label="Etat candidature"
                      :value="currentCandidatureArchive.etatLibelle"
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      label="Date de dépôt"
                      :value="formatDate(currentCandidatureArchive.dateDepot)"
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Date de confirmation"
                      :value="
                        formatDate(currentCandidatureArchive.dateConfirmation)
                      "
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4">
                    <v-text-field
                      label="Date de décision"
                      :value="
                        formatDate(currentCandidatureArchive.dateDecision)
                      "
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      label="Date de finalisation"
                      :value="
                        formatDate(currentCandidatureArchive.dateFinalisation)
                      "
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Motif refus"
                      :value="currentCandidatureArchive.motifRefus"
                      readonly
                      outlined
                      dense
                    />
                  </v-col>
                </v-row>
              </v-form>
              <v-list dense v-if="currentCandidatureArchivePieces.length">
                <div class="text-h6 mt-4 text-center">Pièces associées</div>
                <v-divider></v-divider>
                <v-list-item
                  v-for="piece in currentCandidatureArchivePieces"
                  :key="piece.id"
                >
                  <v-list-item-icon class="align-self-center">
                    <v-icon color="error"> mdi-file-pdf-box </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content class="align-self-center">
                    <v-list-item-title>
                      {{ piece.name }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >( {{ piece.libelleTypePiece }} )
                    </v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action class="align-self-center">
                    <v-btn
                      icon
                      color="primary"
                      @click="telechargerPiece(piece)"
                    >
                      <v-icon> mdi-download </v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                text
                @click="
                  archiveDialogShow = false;
                  currentCandidatureArchive = null;
                  currentCandidatureArchivePieces = [];
                "
              >
                Fermer
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </BaseBlock>
</template>

<script>
import candidatureArchiveRepository from "@/repositories/ApiCandidatureArchiveRepository";
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "BOConsultationArchives",
  components: { BaseBlock },

  data() {
    return {
      searchLoading: false,
      loadingArchiveId: null,
      filtersFormValid: false,
      totalItems: 0,
      filters: {
        etudiantEmailPattern: null,
        dateDepotDebut: null,
        dateDepotFin: null,
      },
      dateDepotDebutMenuShow: false,
      dateDepotFinMenuShow: false,
      options: {
        page: 1,
        itemsPerPage: 5,
        sortBy: [],
        sortDesc: [],
      },
      currentCandidatureArchive: null,
      currentCandidatureArchivePieces: [],
      candidaturesArchives: [],
      headers: [
        { text: "Nom", value: "etudiantNom" },
        { text: "Prénom", value: "etudiantPrenom" },
        { text: "Email", value: "etudiantEmail" },
        { text: "Date de dépôt", value: "dateDepot" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      archiveDialogShow: false,
    };
  },
  created() {
    // this.getCandidaturesArchives();
  },

  methods: {
    async getCandidaturesArchives() {
      const payload = {
        ...this.filters,
        dateDepotDebut: this.filters.dateDepotDebut
          ? new Date(this.filters.dateDepotDebut).toISOString()
          : null,
        dateDepotFin: this.filters.dateDepotFin
          ? new Date(this.filters.dateDepotFin).toISOString()
          : null,
      };

      const params = {
        // Pageable Spring
        page: this.options.page - 1,
        size: this.options.itemsPerPage,

        // Tri ici on ne permet le tri que sur une colone à la fois
        ...(this.options.sortBy.length > 0 && {
          sort: `${this.options.sortBy[0]},${
            this.options.sortDesc[0] ? "desc" : "asc"
          }`,
        }),

        // CandidatureArchiveFilterDto
        ...payload,
      };

      // Supprime les paramètres null/undefined
      Object.keys(params).forEach((key) => {
        if (
          params[key] === null ||
          params[key] === undefined ||
          params[key] === ""
        ) {
          delete params[key];
        }
      });

      try {
        this.searchLoading = true;
        const data = await candidatureArchiveRepository.getCandidaturesArchives(
          params
        );
        this.totalItems = data.totalElements;
        this.candidaturesArchives = data.content;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.searchLoading = false;
      }
    },
    async getCandidatureArchivePieces(candidatureArchiveId) {
      try {
        this.loadingArchiveId = candidatureArchiveId;
        const data =
          await candidatureArchiveRepository.getCandidatureArchivePieces(
            candidatureArchiveId
          );
        this.currentCandidatureArchivePieces = data || [];
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.loadingArchiveId = null;
      }
    },
    async ouvrirArchive(id) {
      this.currentCandidatureArchivePieces = [];

      this.currentCandidatureArchive = this.candidaturesArchives.find(
        (archive) => archive.id === id
      );
      if (!this.currentCandidatureArchive) {
        return;
      }

      await this.getCandidatureArchivePieces(id);

      this.archiveDialogShow = true;
    },
    async telechargerPiece(piece) {
      try {
        this.pieceArchiveLoading = true;
        const data = await candidatureArchiveRepository.telechargerPiece(
          this.currentCandidatureArchive.id,
          piece.id
        );

        const url = window.URL.createObjectURL(data);

        const link = document.createElement("a");
        link.href = url;
        link.download = piece.name;
        link.click();

        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.pieceArchiveLoading = true;
      }
    },
    async supprimerArchive(id) {
      try {
        await candidatureArchiveRepository.supprimerArchive(id);
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    formatDate(date) {
      return new Intl.DateTimeFormat("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).format(new Date(date));
    },
  },
  computed: {
    dateDepotDebutFormatted() {
      return this.filters.dateDepotDebut
        ? this.formatDate(this.filters.dateDepotDebut)
        : null;
    },
    dateDepotFinFormatted() {
      return this.filters.dateDepotFin
        ? this.formatDate(this.filters.dateDepotFin)
        : null;
    },
    dateDepotDebutRules() {
      return [
        () => {
          const debut = this.filters.dateDepotDebut;
          const fin = this.filters.dateDepotFin;

          if (!debut || !fin) return true;

          return (
            debut <= fin ||
            "La date de début doit être antérieure à la date de fin."
          );
        },
      ];
    },

    dateDepotFinRules() {
      return [
        () => {
          const debut = this.filters.dateDepotDebut;
          const fin = this.filters.dateDepotFin;

          if (!debut || !fin) return true;

          return (
            fin >= debut ||
            "La date de fin doit être postérieure à la date de début."
          );
        },
      ];
    },
  },
  watch: {
    // options: {
    //   handler() {
    //     this.getCandidaturesArchives();
    //   },
    //   deep: true,
    // },
    filters: {
      async handler() {
        const validation = await this.$refs.filtersFormRef?.validate();
        if (validation) {
          // Quand un filtre change, on revient à la première page
          this.options.page = 1;
          await this.getCandidaturesArchives();
        }
      },
      deep: true,
    },
  },
};
</script>
